import { Injectable } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WachterUserExt } from '../../../shared/models/wachter-user.model';
import { CodeValuePermitTeam, EthosWachterDepartmentAllItems, PermitsV2MetaDataItemNames, PermitsV2MetaDataLookups } from '../meta-data/permitsv2-meta-data.service';
import { PermitTeamData } from '../models/permit-team-data.model';
import { PermitV2RequestService } from '../services/permit-v2.service';
import { WachterDivisions } from '../meta-data/constants/wachter-divisions.enum';
import { WachterTeams } from '../meta-data/constants/wachter_teams.enum';

@DwCustomContextDefinition({
    keyName: 'permitTeamV2DefaultContext',
    display: 'Permit V2 - Team Default',
    isGlobal: false,
    parentItem: PermitsV2MetaDataItemNames.Permits2Permit
})
@Injectable()
export class PermitTeamV2DefaultContextService extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService,
        private permitV2Service: PermitV2RequestService
    ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            return this.getDefaultPermitTeam(resolvedContext);
        });

        contextDef.attributes = [];

        // Adding a custom attribute to the context so we can select it in the user interface
        this.addProperty(contextDef.attributes, "PermitTeamCodeValueId", "Permit Team Code Value Id", DwAttributeType.Integer);
        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
    }

    getDefaultPermitTeam(resolvedContext: any): Observable<PermitTeamData> {
        const trustUser = new WachterUserExt(this.dwSecurityUserService.securityState.securityContext?.ApplicationUser);

        return this.permitV2Service.getWachterDivisionId(trustUser.wachterDepartmentId)
            .pipe(map(divisionId => {
                return this.getPermitTeamData(divisionId, trustUser);
            }));
    }

    getPermitTeamData(wachterDivisionId: number, trustUser: WachterUserExt): PermitTeamData {
        const permitTeamData: PermitTeamData = {};

        // Set a default so we know it is working
        permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.NSPLBU;
        permitTeamData.CriticalPower = false;

        /* Rules from WI 54239
           NSP (WachterDivisionId=5) - NSP
           LBU (WachterDivisionId=8)- NSP
           WEC (WachterDivisionId=3) - WEC
           NES (WachterDivisionId=3 AND WachterDepartmentId=26 )- NES 
           Rollout (Departmentid= 5 AND WachterDepartmentId=39) - Rollout
        */
        
        // Default is NSP (this handle NSP & LBU)
        permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.NSPLBU;
        
        if (wachterDivisionId == WachterDivisions.Industrial)       // Division is WEC (3), but in the DB it's called industrial
            permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.WEC;
        if (trustUser.wachterDepartmentId == EthosWachterDepartmentAllItems.NWElectricalService)    // Department is NES
            permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.NES;
        if (trustUser.wachterDepartmentId == EthosWachterDepartmentAllItems.NWRollout)  // Department is Rollout (39)
            permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.Rollout;
        if (trustUser.wachterTeamtId == WachterTeams.Rollout_Critical_Power) { // Team is Critical Power (264)
            permitTeamData.PermitTeamCodeValueId = CodeValuePermitTeam.CRITICALPOWER;
            permitTeamData.CriticalPower = true;
        }
        return permitTeamData;
    }
}